var map = {
	"./address_list.svg": "c2dc",
	"./case_item_bg.svg": "334f",
	"./create_team.svg": "0f62",
	"./doc_edit.svg": "7af1",
	"./doc_sem.svg": "1c60",
	"./doc_transform.svg": "fc8f",
	"./intel_write.svg": "d8c5",
	"./inter_oa.svg": "29be",
	"./inter_wps.svg": "13f2",
	"./login.svg": "eeac",
	"./office_edit.svg": "0c4b",
	"./rocket.svg": "3bcd",
	"./slide_1st_bg.svg": "4cf3",
	"./slide_2st_bg.svg": "49d7",
	"./text_check.svg": "f52f",
	"./wps_load_item.svg": "0f10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d87d";